import {showNotification} from "@mantine/notifications";
import {
    AiOutlineExclamation,
    AiOutlineInfo,
    AiOutlineLogin
} from "react-icons/ai";
import config from "../../config";


export const notifySuccess = (message = 'Record saved successfully') => {
    showNotification({
                         title: 'Success',
                         icon: <AiOutlineInfo/>,
                         message: message,
                         color: 'teal',
                     })
}

type NotifiableError = { message?: string, errors?: { message: string }[] };

export const notifyError = (error: unknown = 'Error performing the operation') => {

    console.trace(error);

    const e: NotifiableError = typeof error === 'string'
        ? {message: error}
        : (error ?? {}) as NotifiableError;
    const message = e.message ?? 'Error performing the operation';

    if (typeof e.errors !== 'undefined' && e.errors.length > 0) {
        e.errors.forEach((item) => {
            showErrorNotification(item.message);
        })
    } else {

        showErrorNotification(message);

        const noCurrentUserMessage = 'no current user'
        if (message.toLowerCase() === noCurrentUserMessage) {
            showSessionExpiredNotification();
        }


    }

}

export const showSessionExpiredNotification = (message = 'Redirecting to network portal...Please, wait!') => {

    showNotification({
                         title: 'Session Expired',
                         icon: <AiOutlineLogin/>,
                         message: message,
                         color: 'blue',
                     });


    // Back to the portal's sign-in, returning to THIS app. The console's copy
    // returned to the console.
    window.setTimeout(() => {
        window.location.assign(config.platform.portal + '/sign-in?returnTo=' +
                                   config.hosts.url);
    }, 3000);

};

export const showErrorNotification = (message: string) => {
    showNotification({
                         title: 'Error',
                         icon: <AiOutlineExclamation/>,
                         message: message,
                         color: 'red',
                     })
}


// notify access denied
export const notifyAccessDenied = (message = 'Access denied') => {
    showNotification({
                         title: 'Access Denied',
                         icon: <AiOutlineExclamation/>,
                         message: message,
                         color: 'red',
                     })
}